import CustomAvatar from './CustomAvatar';

export default CustomAvatar;
